import { render, staticRenderFns } from "./FodderForm.vue?vue&type=template&id=7938322f&"
import script from "./FodderForm.vue?vue&type=script&lang=js&"
export * from "./FodderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports